interface PaymentCardProviderTypes {
  VANTIV_DIRECT: number;
  CAYAN: number;
  BRIDGE_PAY: number;
  FIRST_DATA: number;
  VANTIV_DEJAVOO: number;
  MONERIS: number;
  LIGHTSPEED: number;
  LIGHTSPEED_ADYEN: number;
  LSPAY_CAYAN: number;
}

export let PAYMENT_CARD_PROVIDER_TYPES: PaymentCardProviderTypes = {
  VANTIV_DIRECT: 1,
  CAYAN: 10,
  BRIDGE_PAY: 20,
  FIRST_DATA: 40,
  VANTIV_DEJAVOO: 40,
  MONERIS: 60,
  LIGHTSPEED: 80,
  LIGHTSPEED_ADYEN: 81,
  LSPAY_CAYAN: 12
};
